import { taxRateQuery } from "@common/api/tax-rates"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { TaxRateDetailsForm } from "../-components/form/tax-rate-details-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/tax-rates/$taxRateId",
)({
  staticData: { detailSidebar: true },
  loader: ({ context: { queryClient }, params: { taxRateId } }) =>
    queryClient.fetchQuery(taxRateQuery({ tax_rate_id: taxRateId })),
  component: TaxRatePanel,
})

function TaxRatePanel(): React.ReactElement {
  const { taxRateId } = Route.useParams()
  const { data: rate } = useSuspenseQuery(
    taxRateQuery({ tax_rate_id: taxRateId }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({ to: "/settings/quoting/tax-rates", search: true })

  return (
    <TaxRateDetailsForm
      key={`${rate.id}-${rate.deleted_at}`}
      rate={rate}
      onRestore={() => showToast("Restored", "Record restored.", "success")}
      onSave={(saved) =>
        showToast("Saved", `${saved.name} updated.`, "success")
      }
      onClose={close}
    >
      <Outlet />
    </TaxRateDetailsForm>
  )
}
